import classes from './SuccessMessage.module.scss'
import { HiCheckCircle } from 'react-icons/hi'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  hasFixWidth?: boolean
}

const SuccessMessage = ({
  children,
  hasFixWidth = true
}: Props) => {
  const baseClass = classes.SuccessMessage

  const isFixWidth = hasFixWidth
    ? classes.hasFixWidth
    : undefined

  const classnames = [
    baseClass,
    isFixWidth
  ].filter(classname => classname).join(' ')

  return (
    <div
      className={classnames}
      role='status'
    >
      <HiCheckCircle
        aria-hidden
        className={classes.HiCheckCircle}
        size='38px'
      />
      <strong>
        {children}
      </strong>
    </div>
  )
}

export default SuccessMessage
